module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "acConnect__imgs"
  }, [_c('div', {
    staticClass: "acConnect__imgs-item"
  }, [(_vm.singLogo) ? _c('img', {
    attrs: {
      "src": _vm.getImgSrc(_vm.appName, true),
      "alt": _vm.appName,
      "width": "48"
    }
  }) : (_vm.appState) ? _c('img', {
    attrs: {
      "src": _vm.getImgSrc(_vm.appState, false),
      "alt": _vm.appState,
      "width": "48"
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/logos/wechat.svg"),
      "alt": "WeChat",
      "width": "48"
    }
  }), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), (!_vm.singLogo && !_vm.appState) ? [_c('img', {
    staticClass: "acConnect__imgs-arrow",
    attrs: {
      "src": require("../../assets/arrows-horizontal.svg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "acConnect__imgs-item"
  }, [_c('img', {
    attrs: {
      "src": _vm.getImgSrc(_vm.appName),
      "alt": _vm.appName,
      "width": "45"
    }
  })])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-83437a0e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/components/AppLogo.vue
// module id = 389
// module chunks = 1